import { styled } from '@linaria/react';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';

const Desktop = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    display: none;
  }
`;

const Mobile = styled.div`
  display: none;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    display: flex;
  }
`;

const Container = styled.div<{ isNewsCollect?: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  position: relative;
  margin-top: ${({ isNewsCollect }) => (isNewsCollect ? '10px' : '24.5px')};
  margin-bottom: ${({ isNewsCollect }) => (isNewsCollect ? '24px' : '0')};
`;

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Filter = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
`;

const Divide = styled.div`
  width: 2px;
  height: 20px;
  background-color: #e2e8f1;
`;

type TimeAndSearchFilterSkeletonProps = {
  isNewsCollect?: boolean;
};

const TimeAndSearchFilterSkeleton = ({ isNewsCollect }: TimeAndSearchFilterSkeletonProps) => {
  return (
    <Container isNewsCollect={isNewsCollect}>
      <Mobile>
        <RectangleSkeleton width={110} height={28} borderRadius={3} />
      </Mobile>
      <FilterContainer>
        <RectangleSkeleton width={66} height={28} borderRadius={3} />
        <Filter>
          <RectangleSkeleton width={220} height={28} borderRadius={3} />
          <Desktop>
            <Divide />
            <RectangleSkeleton width={110} height={28} borderRadius={3} />
          </Desktop>
        </Filter>
      </FilterContainer>
    </Container>
  );
};

export default TimeAndSearchFilterSkeleton;
